import { defineStore } from "pinia";

export const useAbsenceReasonStore = defineStore('absenceReason', {
    state: () => ({
        absenceReason: {},
        absenceReasons: [],
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading
        },
        setAbsenceReason(absenceReason) {
            this.absenceReason = absenceReason
        },
        setAbsenceReasons(absenceReasons) {
            this.absenceReasons = absenceReasons
        },
        addAbsenceReason(absenceReason) {
            this.absenceReasons.unshift(absenceReason)
        },
        updateAbsenceReason(absenceReason) {
            let index = this.absenceReasons.findIndex(cl => cl.id === absenceReason.id)
            this.absenceReasons.splice(index, 1, absenceReason)
        },
        deleteAbsenceReason(absenceReason) {
            let index = this.absenceReasons.findIndex(cl => cl.id === absenceReason.id)
            this.absenceReasons.splice(index, 1)
        },
    },
});